module.exports = __webpack_public_path__ + "static/media/bus-training.321272ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scss/icons/teaser/bus-training.svg
// module id = 906
// module chunks = 0